module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayDashboardPage() == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Dashboard"
    }
  })], 1) : _c('div', {
    staticClass: "dashboard "
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showIncidentsList() == true) ? _c('div', {
    class: [_vm.showIncidentsList() && _vm.showAccidentsList() ? 'col-lg-6' : 'col-lg-12'],
    staticStyle: {
      "max-height": "215px"
    }
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "170px"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.Incidents.length < 1) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('center', [_c('h2', [_c('b', [_vm._v("No Records")])])])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Incidents), function(Incident) {
    return _c('tr', {
      staticClass: "ng-scope",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "dblclick": function($event) {
          return _vm.redirectToIncident(Incident)
        }
      }
    }, [_c('td', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(_vm._f("fdate4")(Incident.IncidentDate)))]), _vm._v(" "), _c('td', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(Incident.PoolName))]), _vm._v(" "), _c('td', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(Incident.PoolType))])])
  })], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showAccidentsList()) ? _c('div', {
    class: [_vm.showIncidentsList() && _vm.showAccidentsList() ? 'col-lg-6' : 'col-lg-12'],
    staticStyle: {
      "max-height": "215px"
    }
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "170px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.Accidents.length < 1) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('center', [_c('h2', [_c('b', [_vm._v("No Records")])])])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Accidents), function(Accident) {
    return _c('tr', {
      staticClass: "ng-scope",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "dblclick": function($event) {
          return _vm.redirectToIncident(Accident)
        }
      }
    }, [_c('td', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(_vm._f("fdate4")(Accident.IncidentDate)))]), _vm._v(" "), _c('td', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(Accident.PoolName))]), _vm._v(" "), _c('td', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(Accident.PoolType))])])
  })], 2)])])])])]) : _vm._e()]), _vm._v(" "), (_vm.showDailyLog() == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logs.length < 1),
      expression: "logs.length < 1"
    }],
    attrs: {
      "colspan": "11"
    }
  }, [_c('center', [_c('h2', [_c('b', [_vm._v("No Records")])])])], 1)]), _vm._v(" "), _vm._l((_vm.logs), function(item, key) {
    return _c('tr', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "dblclick": function($event) {
          return _vm.redirectToChemrecords(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.AddedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fdate3")(item.AddedOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("ftime")(item.AddedOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.venue))]), _vm._v(" "), _c('td', _vm._l((item), function(value, key) {
      return _c('span', [_vm._v("\n                    " + _vm._s(key == 'Free Chlorine' ? value ? value : '' : '') + "\n                  ")])
    }), 0), _vm._v(" "), _c('td', _vm._l((item), function(value, key) {
      return _c('span', [_vm._v("\n                    " + _vm._s(key == 'pH' ? value : '') + "\n                  ")])
    }), 0), _vm._v(" "), _c('td', _vm._l((item), function(value, key) {
      return _c('span', [_vm._v("\n                    " + _vm._s(key == 'Temperature' ? value ? value + ' °F' : '' : '') + "\n                  ")])
    }), 0), _vm._v(" "), _c('td', _vm._l((item), function(value, key) {
      return _c('span', [_vm._v("\n                    " + _vm._s(key == 'Bather Load (Total)' ? value ? value : '' : '') + "\n                  ")])
    }), 0)])
  })], 2)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showCalendar() == true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.redirectToActivityPatron()
      }
    }
  }, [_c('full-calendar', {
    attrs: {
      "header": {
        left: 'title',
        center: '',
        right: ''
      },
      "events": _vm.events,
      "config": _vm.config
    },
    on: {
      "event-selected": _vm.eventSelected,
      "click": function($event) {
        return _vm.redirectToActivityPatron()
      }
    }
  })], 1)])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v(" Incidents")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date and Time")]), _c('th', [_vm._v("Venue")]), _c('th', [_vm._v("Type")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v("Accidents ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date and Time")]), _vm._v(" "), _c('th', [_vm._v("Venue")]), _vm._v(" "), _c('th', [_vm._v("Type")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v("Daily Log ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr'), _c('tr', [_c('th', [_vm._v("Entered By")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Venue")]), _vm._v(" "), _c('th', [_vm._v("Free Chlorine")]), _vm._v(" "), _c('th', [_vm._v("pH")]), _vm._v(" "), _c('th', [_vm._v("Water Temp")]), _vm._v(" "), _c('th', [_vm._v("Bather Load (Total)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title foof_no_expand_icon"
  }, [_c('h2', [_c('b', [_vm._v("Activity Calendar")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6589a1a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Dashboard.vue
// module id = 823
// module chunks = 1